
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 30","width":"1200","height":"600"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M30 15h30v15zv15H0zH0V0zV0h30z"}})]),_c('path',{attrs:{"d":"M0 0v30h60V0z","fill":"#00247d"}}),_c('path',{attrs:{"d":"M0 0l60 30m0-30L0 30","stroke":"#fff","stroke-width":"6"}}),_c('path',{attrs:{"d":"M0 0l60 30m0-30L0 30","clip-path":"url(#a)","stroke":"#cf142b","stroke-width":"4"}}),_c('path',{attrs:{"d":"M30 0v30M0 15h60","stroke":"#fff","stroke-width":"10"}}),_c('path',{attrs:{"d":"M30 0v30M0 15h60","stroke":"#cf142b","stroke-width":"6"}})])
          )
        }
      }
    